import { Eyebrow, FadeUp, MaskLines } from "./Motion";

const POINTS = [
  { k: "Fresh, every time", v: "Flowers are sourced and strung for your date, never stocked ahead." },
  { k: "Traditional touch", v: "Mini decors, thomala, garlands and dindu made the way they are meant to be." },
  { k: "To your doorstep", v: "Planned three days in advance, packed for freshness and delivered on time." },
];

export const About = () => (
  <section id="about" className="relative overflow-hidden bg-[#FFF8EF] py-14 text-[#240620] sm:py-20" data-testid="about-section">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <Eyebrow className="!text-[#A0216B]">About us</Eyebrow>
        <h2 className="mt-4 font-display text-5xl font-medium leading-[0.95] sm:text-6xl lg:text-7xl">
          <MaskLines lines={["SkandaSri Eventz,", <span key="i" className="italic text-[#A0216B]">flowers at your doorstep.</span>]} />
        </h2>
        <FadeUp delay={0.1} className="mt-8 max-w-xl space-y-4 text-base leading-relaxed text-[#4a2443] sm:text-lg">
          <p>
            SkandaSri Eventz is a flower and décor brand by <strong>LeoFair Events &amp; Entertainments</strong>. We create mini decors,
            fresh garlands, thomala, dindu, door décor, loose flowers and tied flowers for poojas, festivals and every celebration at home.
          </p>
          <p>
            Every order is made to suit your occasion, theme and space — and because each piece is made fresh, we take bookings at least
            three days before your date.
          </p>
        </FadeUp>
      </div>
      <div className="space-y-4 lg:col-span-5 lg:col-start-8 lg:pt-10">
        {POINTS.map((p, i) => (
          <FadeUp key={p.k} delay={i * 0.1} className="border-t border-[#240620]/15 pt-5">
            <h3 className="font-display text-3xl italic">{p.k}</h3>
            <p className="mt-1 text-[#4a2443]">{p.v}</p>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
